<template>
  <td class="text-center">
    <button
      @click="calculate()"
      v-if="!data && !calculating"
      class="btn btn-secondary"
      type="button"
    >
      berechnen
    </button>
    <i v-if="calculating" class="fas fa-sync fa-2x fa-spin spinner"></i>
    <div v-if="data && !calculating">
      <span style="cursor: pointer;" @click="showModal('read')">{{
        data.read
      }}</span>
      /
      <span style="cursor: pointer;" @click="showModal('answered')">{{
        data.answered
      }}</span>
      <i
        @click="calculate()"
        style="cursor: pointer;"
        class="fas fa-sync"
        aria-hidden="true"
      ></i>
    </div>
    <circular-mail-customer-modal
      :show.sync="show"
      :type="type"
      :senderId="model.sender_id"
      v-bind="model"
    ></circular-mail-customer-modal>
  </td>
</template>

<script>
import CircularMailCustomerModal from "@/components/modals/CircularMailCustomerModal";
export default {
  components: {
    CircularMailCustomerModal
  },
  props: ["model", "attribute"],
  data() {
    return {
      calculating: false,
      data: "",
      show: false,
      type: "read"
    };
  },
  methods: {
    showModal(type) {
      this.type = type;
      this.show = true;
    },
    calculate() {
      this.calculating = true;
      this.$http
        .get(`/api/v1/circularMail/read-answer-count/${this.model.id}`)
        .then(response => {
          this.data = response.data;
        })
        .finally(() => {
          this.calculating = false;
        });
    }
  }
};
</script>
